const SET_PARTNERS = (state, payload) => {
  state.partners = payload.partners;
};

export default SET_PARTNERS;
